import gql from 'graphql-tag';

import { sectionEVFragment } from './section-ev';

/**
 * Generic baseline fragment for Application.
 * In general, do not add nested fields that incur additional data resolution.
 */
export const applicationFragment = gql`
  fragment applicationFragment on Application {
    id
    accountId
    navHistory {
      path
    }
    premiseId
    applicationNo
    applicationType
    status
    statusReason
    createdAt
    updatedAt
  }
`;

/**
 * Generic ApplicationSection fragment.
 */
export const applicationSectionFragment = gql`
  fragment applicationSectionFragment on ApplicationSection {
    id
    status
    errors {
      code
      message
    }
  }
`;

/**
 * Contains the entirety of an EV application. Only use this if you need all EV application data.
 */
export const applicationEVFragment = gql`
  fragment applicationEVFragment on ApplicationEV {
    details {
      ...applicationSectionFragment
      ...sectionEVFragment
    }
  }
  ${applicationSectionFragment}
  ${sectionEVFragment}
`;
